module.exports = __webpack_public_path__ + "img/top_banner.cd873678.png";